module.exports = __webpack_public_path__ + "static/img/bg.ca510011.png";